import { render, staticRenderFns } from "./ArchiveReviews.vue?vue&type=template&id=c0efbc28&"
import script from "./ArchiveReviews.vue?vue&type=script&lang=js&"
export * from "./ArchiveReviews.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveReviews.vue?vue&type=style&index=0&id=c0efbc28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports